import {useQuery} from 'react-query';

import {EvalProduct, evalApi} from 'src/lib/api/eval';

export function useEvalSitesOverviewGlobal(window: string = '30d', product?: EvalProduct) {
  const {
    data: overview,
    isLoading,
    isFetching,
    isError,
    error,
    refetch,
  } = useQuery(
    ['eval', 'overview', 'global', window, product ?? 'all'],
    () => evalApi.getSitesOverviewGlobal(window, product),
    {
      keepPreviousData: true,
      staleTime: 30 * 1000,
      cacheTime: 5 * 60 * 1000,
      retry: 1,
      refetchOnWindowFocus: false,
    }
  );

  return {overview, isLoaded: !isLoading, isFetching, isError, error, refetch};
}
